// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (min-width: 1904px) {\n.container {\n    max-width: 1185px;\n}\n.container.container--fluid {\n    max-width: 100%;\n}\n}\n.v-application {\n  font-family: \"Myriad Pro Light\", sans-serif !important;\n}\n.v-application .body-2,\n.v-application .display-1 {\n  font-family: \"Myriad Pro Light\", sans-serif !important;\n}", ""]);
// Exports
module.exports = exports;
